import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';
import { brightlyColors } from './brightlyColors';

const pageThemeGradientstart = brightlyColors.brightlyTeal
const pageThemeGradientEnd = brightlyColors.lightTeal;
const pageHeaderText = brightlyColors.brightlyBlue;

const homeTheme = genPageTheme({ colors: [pageThemeGradientstart, pageThemeGradientEnd], shape: shapes.wave2, options: { fontColor: pageHeaderText } });
const generalTheme = genPageTheme({ colors: [pageThemeGradientstart, pageThemeGradientEnd], shape: shapes.wave, options: { fontColor: pageHeaderText } });

export const brightlyLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: brightlyColors.purple,
      },
      secondary: {
        main: brightlyColors.brightlyBlue,
      },
      background: {
        default: brightlyColors.lightTeal,
        paper: brightlyColors.lightTeal,
      },
      navigation: {
        background: brightlyColors.brightlyBlue,
        indicator: brightlyColors.purple,
        color: brightlyColors.white,
        selectedColor: brightlyColors.brightlyGreen,
      },
    },
  }),
  defaultPageTheme: 'home',
  /* below drives the header colors */
  pageTheme: { home: homeTheme, documentation: generalTheme, tool: generalTheme, service: generalTheme, website: generalTheme, 
    library: generalTheme, other: generalTheme, app: generalTheme, apis: generalTheme 
  },
});